import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-six',
  templateUrl: './theme-six.component.html',
  styleUrls: ['./theme-six.component.css']
})
export class ThemeSixComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
